import { lengthContraction } from '@/domain/physics/SpecialRelativity.js'

export default class BlockElement {
  constructor (name, widthRel, heightRel, initXRel, initYRel, color) {
    this.name = name
    this.widthRel = widthRel
    this.heightRel = heightRel
    this.initXRel = initXRel
    this.initYRel = initYRel

    this.color = color

    this.isDraggable = false
    this.dragBoundFunc = null

    this.x = null
    this.y = null
    this.width = null
    this.height = null
    this.halfWidth = null
    this.halfHeight = null
  }

  setOnScene (sceneWidth, sceneHeight, speedC = null) {
    this.width = sceneWidth * this.widthRel

    if (this.heightRel !== null) {
      this.height = sceneHeight * this.heightRel
    } else {
      this.height = this.width
    }

    if (speedC !== null) {
      this.width = lengthContraction(this.width, speedC)
    }

    this.x = (sceneWidth * this.initXRel) - (this.width / 2)
    this.y = (sceneHeight * this.initYRel) - (this.height / 2)

    this.halfWidth = this.width / 2
    this.halfHeight = this.height / 2
  }

  setDraggable (isDraggable, dragBoundFunc) {
    this.isDraggable = isDraggable
    this.dragBoundFunc = dragBoundFunc
  }

  getConfig () {
    return {
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height,
      fill: this.color,
      draggable: this.isDraggable,
      dragBoundFunc: this.dragBoundFunc
    }
  }
}
